/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeBlockElements.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Block Element Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, October 01, 2018 - 05:25:15 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      10/01/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const BLOCKELEMENT_ADD = 'BLOCKELEMENT_ADD';
export const BLOCKELEMENT_EDIT = 'BLOCKELEMENT_EDIT';
export const BLOCKELEMENT_DELETE = 'BLOCKELEMENT_DELETE';
export const BLOCKELEMENT_OPEN_WARNING = 'BLOCKELEMENT_OPEN_WARNING';
export const BLOCKELEMENT_CLOSE_WARNING = 'BLOCKELEMENT_CLOSE_WARNING';

export const BLOCKELEMENT_EDIT_CONTAINER_LOADED = 'BLOCKELEMENT_EDIT_CONTAINER_LOADED';
export const BLOCKELEMENT_EDIT_CONTAINER_UNLOADED = 'BLOCKELEMENT_EDIT_CONTAINER_UNLOADED';
export const BLOCKELEMENT_EDIT_FORM_LOADED = 'BLOCKELEMENT_EDIT_FORM_LOADED';
export const BLOCKELEMENT_EDIT_FORM_UNLOADED = 'BLOCKELEMENT_EDIT_FORM_UNLOADED';

export const BLOCKELEMENT_UPDATE_FIELD = 'BLOCKELEMENT_UPDATE_FIELD';
export const BLOCKELEMENT_EDIT_FIELDSET_LOADED = 'BLOCKELEMENT_EDIT_FIELDSET_LOADED';

export const BLOCKELEMENT_UPDATE_VALUE = 'BLOCKELEMENT_UPDATE_VALUE';
export const BLOCKELEMENT_SET_ELEMENTTYPE_SELECT = 'BLOCKELEMENT_SET_ELEMENTTYPE_SELECT';
export const BLOCKELEMENT_SET_DATATYPE_SELECT = 'BLOCKELEMENT_SET_DATATYPE_SELECT';
export const BLOCKELEMENT_EDIT_DATA_LOAD = 'BLOCKELEMENT_EDIT_DATA_LOAD';
export const BLOCKELEMENT_EDIT_ELEMENTOPTIONS_LOAD = 'BLOCKELEMENT_EDIT_ELEMENTOPTIONS_LOAD';
export const BLOCKELEMENT_EDIT_ELEMENTOPTIONS_DRAW = 'BLOCKELEMENT_EDIT_ELEMENTOPTIONS_DRAW';
export const BLOCKELEMENT_EDIT_VALIDATIONTYPES_LOAD = 'BLOCKELEMENT_EDIT_VALIDATIONTYPES_LOAD';
export const BLOCKELEMENT_EDIT_VALIDATIONTYPES_DRAW = 'BLOCKELEMENT_EDIT_VALIDATIONTYPES_DRAW';
export const BLOCKELEMENT_EDIT_FIELDSETGROUPS_LOAD = 'BLOCKELEMENT_EDIT_FIELDSETGROUPS_LOAD';

export const BLOCKELEMENT_EDIT_CONTAINER_SUBMIT = 'BLOCKELEMENT_EDIT_CONTAINER_SUBMIT';
export const BLOCKELEMENT_EDIT_CONTAINER_CANCEL = 'BLOCKELEMENT_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeBlockElements.js